// filepath: d:\src\com.argodata.cdt.qd2.admin.muiconv\src\components\drawers\QuestionnaireSampleSurveyDrawerHook.js
import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from "prop-types";
import {connect, useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import {closeDrawer, openDrawer, publish} from "../../actions/drawerActions";
import {
    questionnaireTemplateInit,
    getQuestionnaireTemplate,
    getQuestionnaireReference,
    getMetadataRequiredTokens,
    clearMetadataRequiredTokens,
    saveQuestionnaireTemplate,
    clearQuestionnaireReference,
    getQuestionnaireVersions,
    clearQuestionnaireVersions
}
    from "../../actions/questionnaireTemplateActions";
import {initGetTemplateList} from "../../actions/templateListActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ArgoTextFieldHook from "../common/ArgoTextFieldHook";
import ArgoButtonHook from "../common/ArgoButtonHook";
import {QD_URL} from '../../constants/systemConstants';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ArgoIconButtonHook from "../common/ArgoIconButtonHook";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import * as expander from "../../utilities/expander";
import TemplateApi from "../../api/TemplateApi";
import ArgoSectionOpenCloseHook from "../common/ArgoSectionOpenCloseHook";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import * as TEMPLATE from "../../constants/templateConstants";
import {useNavigate} from "react-router-dom";
import Switch from '@mui/material/Switch';
import FormControlLabel from "@mui/material/FormControlLabel";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities"
import QuestionnairePublishOrChangeDateDrawerHook, {questionnairePublishOrChangeDateDrawerProps} from "./QuestionnairePublishOrChangeDateDrawerHook";


// const leftCurlyBracket = "{";
// const rightCurlyBracket = "}";
// const standardIndent = "50px";
// const metadataIndent = "90px";

const QuestionnaireSampleSurveyDrawerHook = (props) => {
    const navigate = useNavigate();
    // Initial state setup
    const [readToRender, setReadToRender] = useState(false);
    const [isPublishedOrPending, setIsPublishedOrPending] = useState(false);
    // const [sendJsonNotSet, setSendJsonNotSet] = useState(true);
    // const [sendJson, setSendJson] = useState({metadata: {}});
    // const [templateSendJson, setTemplateSendJson] = useState("");
    // const [fullMetadataTokenArray, setFullMetadataTokenArray] = useState(ALLOWED_TOKEN);
    // const [unusedMetadataTokenArray, setUnusedMetadataTokenArray] = useState(ALLOWED_TOKEN);
    const [disableAdd, setDisableAdd] = useState(true);
    // const [metadataCurrentIndex, setMetadataCurrentIndex] = useState(0);
    // const [metadataArray, setMetadataArray] = useState([]);
    // const [newMetadataToken, setNewMetadataToken] = useState("");
    // const [newMetadataValue, setNewMetadataValue] = useState("");
    // const [metadataSaved, setMetadataSaved] = useState(false);
    const [tokensArr, setTokensArr] = useState([]);
    const [metadataArr, setMetadataArr] = useState([]);
    const [metadataErrorText, setMetadataErrorText] = useState("");
    const [totalErrorText, setTotalErrorText] = useState("");
    const [sendDetails, setSendDetails] = useState({});
    const [sendSectionMetadataOpen, setSendSectionMetadataOpen] = useState(false);
    const [requestSectionMetadataOpen, setRequestSectionMetadataOpen] = useState(false);
    // const [showPreviousProperties, setShowPreviousProperties] = useState(false);
    const [previousPropertyExists, setPreviousPropertyExists] = useState(false);
    const [requiredTokens, setRequiredTokens] = useState(undefined);
    const [versionCount, setVersionCount] = useState(0);
    // const [displayToggle, setDisplayToggle] = useState({display: true, done: false, noPrevPublished: false});
    const [loaded, setLoaded] = useState(false);
    const [currentVersionHasTestData, setCurrentVersionHasTestData] = useState(true);
    const [hideToggle, setHideToggle] = useState(false)
    const [latestTemplate, setLatestTemplate] = useState({});
    const [initialLoad, setInitialLoad] = useState(true)

    const dispatch = useDispatch();
    const versionsList = useSelector(state => state.questionnaireVersion.versions);

    // Replace componentDidMount
    useEffect(() => {
        props.getQuestionnaireVersions(props.template.templateKey)
        getTestDataAndRequiredTokens(props.template.templateKey, props.template.id);
        setDisableAdd(true)

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                closeDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)
        setInitialLoad(true)

        return () => {
            document.removeEventListener("keydown", handleKeyDown, true)
            dispatch(clearQuestionnaireVersions());
            dispatch(clearMetadataRequiredTokens());
            dispatch(clearQuestionnaireReference());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Helper functions
    const getTestDataAndRequiredTokens = useCallback((key, id) => {
        props.getQuestionnaireTemplate(key, id);
        props.getMetadataRequiredTokens(id);
    }, [props]);

    // Replace componentWillReceiveProps
    useEffect(() => {
        if (versionsList.length > 0) {
            // let tempQuestionnaireTemplate = {...props.questionnaireTemplate[props.template.templateKey]};

            // if (tempQuestionnaireTemplate) {
            //     let tempSendJson = {metadata: {}};
                // let tempTemplateSendJson = {metadata: {}};

                // if (tempQuestionnaireTemplate.metadata !== undefined && tempQuestionnaireTemplate.metadata.hasOwnProperty("sendJSON")) {
                //     tempSendJson = JSON.parse(tempQuestionnaireTemplate.metadata["sendJSON"]);
                //     tempTemplateSendJson = tempQuestionnaireTemplate.metadata["sendJSON"];
                // }

                // let tempUnusedMetadataTokenArray = fullMetadataTokenArray;
                // for (let key in tempSendJson.metadata) {
                //     tempUnusedMetadataTokenArray = tempUnusedMetadataTokenArray.filter(e => e !== key); // remove used token
                // }

                // let tempMetadataArray = [];
                // for (let key in tempSendJson.metadata) {
                //     if (tempSendJson.metadata.hasOwnProperty(key)) {
                //         tempMetadataArray.push({token: [key], value: tempSendJson.metadata[key]});
                //     }
                // }

                // let tempIsPublished = false;

                // let publishedDate = props.template.publishedDate;
                // if (publishedDate !== null) {
                //     let todayDate = new Date();
                //
                //     let currentDayOfMonth = todayDate.getDate();
                //     let currentMonth = todayDate.getMonth() + 1; // Be careful! January is 0, not 1
                //     let currentYear = todayDate.getFullYear();
                //
                //     let todayYearMonthDay = currentYear.toString() + ((currentMonth < 10) ? ("0" + currentMonth) : currentMonth) + ((currentDayOfMonth < 10) ? ("0" + (currentDayOfMonth)) : currentDayOfMonth);
                //
                //     let startDateYearMonthDay = formatDateDisplay(props.template.startDate, "YearMonthDay");
                //     let endDateYearMonthDay = formatDateDisplay(props.template.endDate, "YearMonthDay");
                //
                //     if ((endDateYearMonthDay === "") && (startDateYearMonthDay <= todayYearMonthDay)) {
                //         tempIsPublished = true;
                //     } else if ((startDateYearMonthDay <= todayYearMonthDay) && (endDateYearMonthDay > todayYearMonthDay)) {
                //         tempIsPublished = true;
                //     }
                // }

            // if ((endDateYearMonthDay === "") && (startDateYearMonthDay <= todayYearMonthDay)) {
                //         tempIsPublished = true;
                //     } else if ((startDateYearMonthDay <= todayYearMonthDay) && (endDateYearMonthDay > todayYearMonthDay)) {
                //         tempIsPublished = true;
                //     }

            let isoDate = new Date();
            let day = isoDate.getDate();
            let month = isoDate.getMonth() + 1; // Be careful! January is 0, not 1
            let year = isoDate.getFullYear();
            const todayDate = `${year}-${month}-${day}`

            let startDate = versionsList.at(-1).startDate
            const pending = todayDate < startDate
            setReadToRender(true);
            setIsPublishedOrPending(versionsList.at(-1).isActive || pending);
                // setSendJsonNotSet(false);
                // setSendJson(tempSendJson);
                // setTemplateSendJson(tempTemplateSendJson);
                // setMetadataArray(tempMetadataArray);
                // setUnusedMetadataTokenArray(tempUnusedMetadataTokenArray);
            setVersionCount(versionsList[versionsList.length - 1].numberOfVersionsCount);
            // }

            // if (!displayToggle.done && props.questionnaireTemplate?.[props.template.templateKey]?.["testData"] !== undefined) {
            //     setDisplayToggle({
            //         display: Object.entries(props.questionnaireTemplate?.[props.template.templateKey]?.["testData"]).length === 0,
            //         done: true
            //     });
            // }
        }
    }, [props.questionnaireTemplate, props.template, versionsList]);

    useEffect(() => {
        createTokensAndMetadataProperties(props, props.questionnaireTemplate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.questionnaireRequiredTokens, props.questionnaireTemplate]);

    useEffect(() => {
        doesCurrentVersionHasTestData();
        if (!currentVersionHasTestData) {
            getPreviousValue();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [versionsList, currentVersionHasTestData]);

    const doesCurrentVersionHasTestData = () => {
        if (versionsList.length > 0 && Object.keys(versionsList.at(-1).testData).length === 0){
            setCurrentVersionHasTestData(false);
        }
    }

    const createTokensAndMetadataProperties = useCallback((currentProps, questionnaireTemplate) => {
        let allFilledProps = questionnaireTemplate?.[currentProps.template.templateKey]?.["testData"];
        let allFilledTokensArr = [];
        let allFilledMetadataArr = [];
        let currentRequiredTokens = requiredTokens || currentProps.questionnaireRequiredTokens;
        if (allFilledProps && currentRequiredTokens) {
            setLoaded(true)
            for (const key in allFilledProps) {
                if (currentRequiredTokens.includes(key)) allFilledTokensArr.push([key, allFilledProps[key]]);
                else if (key === "testMode"
                    || key === "requestTimestamp"
                    || key === "EngagementInstanceId"
                    || key === "UniversalConsumerId") continue
                else if (previousPropertyExists && currentProps.questionnaireRequiredTokens.includes(key)) continue
                else allFilledMetadataArr.push([key, allFilledProps[key]]);
            }
            for (const token of currentRequiredTokens) {
                if (!allFilledTokensArr.some(entry => entry[0] === token)) allFilledTokensArr.push([token, ""]);
            }
        }

        allFilledTokensArr.sort((a, b) => a[0].toLowerCase().localeCompare(b[0].toLowerCase()));
        allFilledMetadataArr.sort((a, b) => a[0].toLowerCase().localeCompare(b[0].toLowerCase()));

        allFilledTokensArr.push(["EngagementInstanceId", initialLoad ? "Test_EngagementInstanceId" : allFilledProps?.["EngagementInstanceId"]])
        allFilledTokensArr.push(["UniversalConsumerId", initialLoad ? "Test_UniversalConsumerId" : allFilledProps?.["UniversalConsumerId"]])

        setTokensArr(allFilledTokensArr);
        setMetadataArr(allFilledMetadataArr);
        setRequiredTokens(currentRequiredTokens);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previousPropertyExists, requiredTokens, props.questionnaireRequiredTokens]);

    const getPreviousValue = () => {
        let publishedTemplates = versionsList.filter(template => template.status.name === "Published");
        publishedTemplates.pop();
        if (publishedTemplates.length > 0) {
            let tempLatestTemplate = undefined;
            for (let i = publishedTemplates.length - 1; i >= 0; i--) {
                //if (tempLatestTemplate) break;
                if (Object.entries(publishedTemplates[i]?.testData).length > 0) {
                    tempLatestTemplate = publishedTemplates[i];
                    break;
                }
            }
            if (tempLatestTemplate) {
                setLatestTemplate(tempLatestTemplate);
                setPreviousPropertyExists(true);
                //getTestDataAndRequiredTokens(latestTemplate.templateKey, latestTemplate.id);
            }
        }
        else setPreviousPropertyExists(false);
    }

    const showPreviousValues = useCallback((event) => {
        if (event.target.checked) {
            getTestDataAndRequiredTokens(latestTemplate.templateKey, latestTemplate.id);
            // setDisplayToggle({
            //     display: true,
            //     done: displayToggle.done,
            //     noPrevPublished: false
            // });
        } else if (event.target.checked === false) {
            let latestTemplateClone = portalShared.cloneObj(latestTemplate);
            latestTemplateClone.testData = {};
            createTokensAndMetadataProperties(props, {[latestTemplateClone.templateKey]: latestTemplateClone});
            // setDisplayToggle({
            //     display: false,
            //     done: displayToggle.done,
            //     noPrevPublished: false
            // });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.template, getTestDataAndRequiredTokens, latestTemplate]);

    useEffect(() => {
        if(loaded) checkForErrorsOnScreen();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokensArr, metadataArr, versionsList, previousPropertyExists, requiredTokens]);

    const checkForErrorsOnScreen = useCallback(() => {
        let tempMetadataErrorText = "";
        let tempTotalErrorText = "";
        if (metadataArr.some(entry => entry[0] === "")) tempMetadataErrorText = "Metadata name cannot be blank";

        if (metadataArr.some(entry => entry[1] === ""))
            tempMetadataErrorText !== "" ? tempMetadataErrorText += ", Metadata values cannot be blank" : tempMetadataErrorText = "Metadata values cannot be blank";

        if (tokensArr.some(entry => entry[1] === ""))
            tempMetadataErrorText !== "" ? tempMetadataErrorText += ", Token values cannot be blank" : tempMetadataErrorText = "Token values cannot be blank";

        const noDuplicateKeys = new Set();

        //checks for duplicate by creating a set and comparing size
        tokensArr.forEach(([key]) => noDuplicateKeys.add(key));
        metadataArr.forEach(([key]) => noDuplicateKeys.add(key));
        if (noDuplicateKeys.size !== tokensArr.length + metadataArr.length)
            tempMetadataErrorText !== "" ? tempMetadataErrorText += ", Duplicate Token/Metadata names" : tempMetadataErrorText = "Duplicate Token/Metadata names";

        if (metadataArr.some(entry => entry[0] === "testMode"))
            tempMetadataErrorText !== "" ? tempMetadataErrorText += ", Metadata name cannot be testMode" : tempMetadataErrorText = "Metadata name cannot be testMode";

        if (metadataArr.some(entry => entry[0] === "requestTimestamp"))
            tempMetadataErrorText !== "" ? tempMetadataErrorText += ", Metadata name cannot be requestTimestamp" : tempMetadataErrorText = "Metadata name cannot be requestTimestamp";

        if (tempMetadataErrorText !== "") tempTotalErrorText = "Resolve metadata errors";

        // if (!isPublishedOrPending) {
        //     if (tempTotalErrorText !== "") tempTotalErrorText += ", Questionnaire is not published";
        //     else tempTotalErrorText = "Questionnaire is not published";
        // }
        
        setMetadataErrorText(tempMetadataErrorText);
        setTotalErrorText(tempTotalErrorText);
        setDisableAdd(tempMetadataErrorText !== "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokensArr, metadataArr, versionsList]);

    // const onSelectChange = useCallback((event, fieldName) => {
    //     let value = event.target.value;
    //     // Using functional state update pattern for better reliability
    //     if (fieldName === 'newMetadataToken') {
    //         setNewMetadataToken(value);
    //     }
    //     // Add more conditions if needed for other fields
    // }, []);

    const onTextChange = useCallback((name, event, fieldName, index) => {
        let newValue = event.target.value;
        if (fieldName.includes("newRequiredTokensValue")) {
            let tempTokensArr = portalShared.cloneObj(tokensArr);
            tempTokensArr[index][1] = newValue;
            setTokensArr(tempTokensArr);
        } else if (fieldName.includes("newMetadataValue")) {
            let tempMetadataArr = portalShared.cloneObj(metadataArr);
            tempMetadataArr[index][1] = newValue;
            setMetadataArr(tempMetadataArr);
        } else {
            let tempMetadataArr = portalShared.cloneObj(metadataArr);
            tempMetadataArr[index][0] = newValue;
            setMetadataArr(tempMetadataArr);
        }
    }, [tokensArr, metadataArr]);

    // const addTokenAndValueLine = useCallback((addToSendObj, key, value, indentPx = "60px", index = 0, isURL = false, valueBlack = false) => {
    //     let displayValue = (value === null) ? "" : value;
    //
    //     if (addToSendObj && (key !== "") && (value !== "{") && (value !== "}")) {
    //         let tempSendJson = {...sendJson};
    //         let jsonChanged = false;
    //
    //         if (!tempSendJson.hasOwnProperty("metadata")) {
    //             tempSendJson["metadata"] = {};
    //         }
    //
    //         // If not metadata and key does not exist then add key
    //         if ((indentPx !== metadataIndent) && !tempSendJson.hasOwnProperty(key)) {
    //             tempSendJson[key] = value;
    //             jsonChanged = true;
    //         } else if ((indentPx === metadataIndent) && (!tempSendJson.metadata.hasOwnProperty(key))) {
    //             tempSendJson.metadata[key] = value;
    //             jsonChanged = true;
    //         }
    //
    //         if (jsonChanged) {
    //             setSendJson(tempSendJson);
    //         }
    //     }
    //
    //     return <div key="div01" style={{display: "flex", alignItems: "center", width: "100%"}}>
    //         <div key={key + "1" + index} style={{width: indentPx, paddingTop: "10px"}}>&nbsp;</div>
    //         <div key={key + "2" + index}>
    //             {key === "" ?
    //                 <div key="div02" style={{float: "left", fontSize: "14pt", color: "black"}}>{key}</div>
    //                 :
    //                 <div key="div03"
    //                      style={{float: "left", fontSize: "14pt", color: "red"}}>{'"' + key + '"'} &nbsp;</div>
    //             }
    //         </div>
    //         <div key={key + "3" + index}>
    //             {key === "" ?
    //                 <div key="div04" style={{float: "left", fontSize: "14pt"}}>{key}</div>
    //                 :
    //                 <div key="div05" style={{float: "left", fontSize: "14pt"}}>:</div>
    //             }
    //         </div>
    //         <div key={key + "4" + index} style={{float: "left", fontSize: "14pt",}}>&nbsp;</div>
    //         <div key={key + "5" + index}>
    //             {isURL ?
    //                 <div key="div05" style={{
    //                     float: "left",
    //                     fontSize: "14pt",
    //                     color: "blue",
    //                     textDecoration: "underline"
    //                 }}>{'"' + displayValue + '"'}</div>
    //                 :
    //                 <div key="div06" style={{
    //                     float: "left",
    //                     fontSize: "14pt",
    //                     color: valueBlack ? "black" : "blue"
    //                 }}>{valueBlack ? displayValue : ('"' + displayValue + '"')}</div>
    //             }
    //         </div>
    //         <div key={key + "6" + index} style={{paddingLeft: "15px"}}>
    //             &nbsp;&nbsp;&nbsp;
    //             {((indentPx === metadataIndent) && (index !== -1)) ?
    //                 <ArgoButtonHook
    //                     fileName="QuestionnaireSampleSurveyDrawer"
    //                     fieldName="remove"
    //                     label="REMOVE"
    //                     width={100}
    //                     onClick={removeMetadata}
    //                 />
    //                 :
    //                 ""
    //             }
    //         </div>
    //         <div key={key + "7" + index} style={{float: "clear"}}></div>
    //     </div>;
    // }, [sendJson]);

    // const metadataAddLine = useCallback(() => {
    //     return <div key="metadataAddLine01" style={{display: "flex", width: "100%"}}>
    //         <div key="metadataAddLine03-ADD-button" style={{alignItems: "left", paddingTop: '14px'}}>
    //             <ArgoButtonHook
    //                 fileName="QuestionnaireSampleSurveyDrawer"
    //                 fieldName="add"
    //                 label="ADD"
    //                 width={100}
    //                 style={{textAlign: "center", padding: "10px"}}
    //                 onClick={changeMetadataAddModeToFalse}
    //             />
    //         </div>
    //         <div key="metadataAddLine03" style={{float: "clear"}}></div>
    //     </div>;
    // }, []);

    const addEmptyMetadata = useCallback(() => {
        let tempMetadataArr = portalShared.cloneObj(metadataArr);
        tempMetadataArr.push(["", ""]);
        setMetadataArr(tempMetadataArr);
    }, [metadataArr]);

    const removeMetadata = useCallback((index) => {
        let tempMetadataArr = portalShared.cloneObj(metadataArr);
        tempMetadataArr.splice(index, 1);
        setMetadataArr(tempMetadataArr);
    }, [metadataArr]);

    const displayMetadataLine = useCallback((name = "", value = "", index) => {
        return <div key="displayMetadataLine01" style={{display: "flex", width: "100%"}}>
            <div id="QuestionnaireSampleSurveyDrawer-metadata-container-div"
                 style={{float: "left", paddingTop: "10px"}}>
                <ArgoTextFieldHook
                    fileName="QuestionnaireSampleSurveyDrawer"
                    fieldName={`newMetadataName${index}`}
                    index={index}
                    label="Metadata Name"
                    value={name}
                    onChange={onTextChange.bind(null, name)}
                    width="200px"
                />
            </div>

            <div id="QuestionnaireSampleSurveyDrawer-spacer-div-2"
                 style={{float: "left", fontSize: "14pt", paddingTop: "30px"}}>&nbsp; : &nbsp;</div>

            <div id="QuestionnaireSampleSurveyDrawer-spacer-div-3"
                 style={{float: "left", fontSize: "14pt", width: "10px"}}>&nbsp;</div>

            <div key="displayMetadataLine06" style={{float: "left", fontSize: "14pt", paddingTop: "10px"}}>
                <ArgoTextFieldHook
                    fileName="QuestionnaireSampleSurveyDrawer"
                    fieldName={`newMetadataValue${index}`}
                    index={index}
                    label="Metadata Value"
                    value={value}
                    onChange={onTextChange.bind(null, name)}
                    width="300px"
                />
            </div>

            <div id="QuestionnaireSampleSurveyDrawer-spacer-div-4"
                 style={{float: "left", fontSize: "14pt"}}>&nbsp;</div>

            <ArgoIconButtonHook
                fileName="QuestionnaireSampleSurveyDrawer"
                fieldName="remove"
                onClick={removeMetadata.bind(null, index)}
                index={props.index}
                icon={<HighlightOffOutlinedIcon style={{color: expander.ICON_COLOR}}/>}
                display={props.showIconButtonRemove}
                marginTop={"50%"}
            />
            <div id="QuestionnaireSampleSurveyDrawer-clear-div" style={{float: "clear"}}></div>
        </div>;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onTextChange, removeMetadata]);

    // const saveMetadata = useCallback(() => {
    //     if (newMetadataToken) {
    //         let token = unusedMetadataTokenArray[newMetadataToken];
    //         let tempMetadataArray = metadataArray; // get current used metadata tokens
    //         let tempUnusedMetadataTokenArray = unusedMetadataTokenArray.filter(e => e !== token); // remove used token
    //
    //         tempMetadataArray.push({token: token, value: newMetadataValue});
    //
    //         setNewMetadataToken("");
    //         setNewMetadataValue("");
    //         setMetadataCurrentIndex(metadataCurrentIndex + 1);
    //         setUnusedMetadataTokenArray(tempUnusedMetadataTokenArray);
    //         setMetadataArray(tempMetadataArray);
    //     }
    // }, [newMetadataToken, unusedMetadataTokenArray, metadataArray, newMetadataValue, metadataCurrentIndex]);

    // const cancelMetadata = useCallback(() => {
    //     setNewMetadataToken("");
    //     setNewMetadataValue("");
    // }, []);

    const displayRequiredTokens = useCallback((name, value, index) => {

        return <div key="displayRequiredTokensLine01" style={{display: "flex", width: "100%"}}>
            <div id="QuestionnaireSampleSurveyDrawer-RequiredTokens-container-div"
                 style={{float: "left", paddingTop: "10px"}}>
                <ArgoTextFieldHook
                    fileName="QuestionnaireSampleSurveyDrawer"
                    fieldName={`newRequiredTokensName${index}`}
                    label="Token Name"
                    value={name}
                    disabled={true}
                    width="200px"
                />
            </div>

            <div id="QuestionnaireSampleSurveyDrawer-spacer-div-2"
                 style={{float: "left", fontSize: "14pt", paddingTop: "30px"}}>&nbsp; : &nbsp;</div>

            <div id="QuestionnaireSampleSurveyDrawer-spacer-div-3"
                 style={{float: "left", fontSize: "14pt", width: "10px"}}>&nbsp;</div>

            <div key="displayMetadataLine06" style={{float: "left", fontSize: "14pt", paddingTop: "10px"}}>
                <ArgoTextFieldHook
                    fileName="QuestionnaireSampleSurveyDrawer"
                    fieldName={`newRequiredTokensValue${index}`}
                    index={index}
                    label="Token Value"
                    value={value}
                    onChange={onTextChange.bind(null, name)}
                    width="300px"
                />
            </div>
        </div>;
    }, [onTextChange]);

    const sendJSON = useCallback(() => {
        let tempSendJson = 
            {...Object.fromEntries(tokensArr), ...Object.fromEntries(metadataArr), testMode: true};

        TemplateApi.updateQuestionnaireMetadata(tempSendJson, props.template.id).then(() => {
            getTestDataAndRequiredTokens(props.template.templateKey, props.template.id);
            createTokensAndMetadataProperties(props, props.questionnaireTemplate);
        });

        // NOTE: because the sendJson object is saved in the questionnaire metadata
        // when moved between servers the questionnaire.id will change and is required
        // when you GET a questionnaire reference key.  This was causing portal to
        // malfunction getting the wrong metadata for the template.
        tempSendJson = {
            metadata: {
                ...Object.fromEntries(tokensArr), ...Object.fromEntries(metadataArr),
                testMode: true
            }
        };
        // tempSendJson.referenceUrl = "http://localhost:3001/qd2portal/"; // NO more sending reference URL per Nirav
        tempSendJson.questionnaireTemplateId = props.template.id;
        props.getQuestionnaireReference(tempSendJson);
        setSendDetails(tempSendJson);
        setHideToggle(true)
        setInitialLoad(false)
    }, [tokensArr, metadataArr, getTestDataAndRequiredTokens, createTokensAndMetadataProperties, props]);

    // const saveJSON = useCallback(() => {
    //     let updatedTemplate = portalShared.cloneObj(props.questionnaireTemplate[props.template.templateKey]);
    //
    //     let tempSendJson = {metadata: sendJson.metadata};
    //     updatedTemplate.metadata["sendJSON"] = JSON.stringify(tempSendJson);
    //
    //     updatedTemplate.startDate = null;
    //     updatedTemplate.endDate = null;
    //     updatedTemplate.notes = null;
    //
    //     setIsPublished(false);
    //     setTemplateSendJson(updatedTemplate.metadata["sendJSON"]);
    //     setMetadataSaved(true);
    //
    //     props.saveQuestionnaireTemplate(updatedTemplate);
    // }, [sendJson, props]);

    const closeDrawer = useCallback(() => {
        // if (metadataSaved) {
        //     props.savePortalReferenceJson(closeCreatePortalRefKeyDrawer); // Tell questionnaire list screen that it needs to relaod because portal reference key was saved
        // }

        props.closeDrawer();
    }, [props]);

    const onClickToggleSectionOpenClose = useCallback((name) => () => {
        if (name === "send") setSendSectionMetadataOpen(!sendSectionMetadataOpen);
        else if (name === "request") setRequestSectionMetadataOpen(!requestSectionMetadataOpen);
    }, [sendSectionMetadataOpen, requestSectionMetadataOpen]);

    const openVersionsScreen = useCallback((key, name, nameQualifier) => {
        props.initGetTemplateList(props.versionsFilter, props.templateType, TEMPLATE.MODE.VERSIONS, key, name, nameQualifier, props.defaultActions);

        let path = QD_URL + "/" + props.templateType + "-versions/" + key;
        navigate(path, {replace: true});
        closeDrawer();
    }, [props, navigate, closeDrawer]);

    const openPublishScreen = useCallback((template, name, nameQualifier) => {
        props.openDrawer(questionnairePublishOrChangeDateDrawerProps, <QuestionnairePublishOrChangeDateDrawerHook
            mode="Publish:"
            title={name}
            qualifier={nameQualifier}
            buttonLabel="PUBLISH"
            template={template}
            currentStartDate={""}
            action={props.publish}
            setLoadingState={props.setLoadingState}/>, template);
    }, [props]);

    // Render the component
    let rtnJsonObj = props.questionnaireReference;
    let isDraft = props.template.status.name === "Draft"
    return (
        <ClickAwayListener onClickAway={(event) => {
            // Checks is target is BODY first because portal preview DDLBs cause target to be body and we shouldn't close on that
            if (event.target.tagName !== 'BODY') closeDrawer();
        }}>
            <div key="baseDiv" style={{height: "100%"}}>
                {readToRender ?
                    <div key="baseDiv" style={{height: "100%"}}>
                        <ArgoAppBarHook
                            title={"Create Sample Survey:"}
                            titleFor={props.template.name}
                            qualifierFor={props.template.nameQualifier}
                            showMenuArrowButton="LEFT"
                            onLeftIconButtonTouchTap={closeDrawer}
                            isDrawer={true}
                            width={questionnaireSampleSurveyDrawerProps.width}
                        />

                        <div style={{height: '64px'}}></div>

                        {isPublishedOrPending ?
                            <div key="MainParentDivSendJson" style={{height: "90%"}}>
                                <div key="SendJson02" style={{height: "40px", paddingLeft: "40px"}}><h2><b>Create
                                    Sample
                                    Survey</b></h2></div>
                                <div key="SendJson03" style={{height: "10px"}}>&nbsp;</div>
                                {previousPropertyExists && !currentVersionHasTestData && !hideToggle ?
                                    <FormControlLabel id="toggleKey" style={{paddingLeft: "40px", margin: "0px"}}
                                                      control={<Switch color="primary"/>}
                                                      label="Fill in values from the last published version?"
                                                      labelPlacement="start"
                                                      onChange={showPreviousValues}
                                    />
                                    : currentVersionHasTestData || hideToggle ? "" :
                                    <div style={{paddingLeft: "40px", color: "gray", fontSize: "18px"}}>
                                        <b>No previously published version or previous test data exists</b>
                                    </div>
                                }
                                <div key="SendJson05" style={{display: "flex"}}>
                                    {tokensArr.length > 0 ?
                                        <div key="SendJson06" style={{paddingLeft: "40px"}}>
                                            <div key="SendJson07" style={{height: "40px"}}><h3><b>Required
                                                Tokens/Metadata</b>
                                            </h3></div>
                                            <div key="SendJson08" style={{height: "10px"}}>&nbsp;</div>
                                            <div key="SendJsonRequiredTokens">
                                                {tokensArr.map(([name, value], index) =>
                                                    <div
                                                        key={`SendJson${index}`}>{displayRequiredTokens(name, value, index)}</div>)
                                                }
                                            </div>
                                        </div> : ""
                                    }
                                    <div style={{paddingLeft: "40px"}}>
                                        <div key="SendJson09" style={{height: "40px"}}>
                                            <h3><b>Additional Metadata</b></h3>
                                        </div>
                                        <div key="SendJson10" style={{height: "10px"}}>&nbsp;</div>
                                        {metadataArr.length > 0 ?
                                            <div key="SendJsonMetadata">
                                                {metadataArr.map(([name, value], index) =>
                                                    <div
                                                        key={`SendJson${index}`}>{displayMetadataLine(name, value, index)}</div>)
                                                }
                                            </div> : ""
                                        }
                                        <div key="SendJsonMetadataAddMode">
                                            <div key="metadataAddLine01" style={{display: "flex", width: "100%"}}>
                                                <div key="metadataAddLine03-ADD-button"
                                                     style={{alignItems: "left", paddingTop: '14px'}}>
                                                    <ArgoButtonHook
                                                        fileName="QuestionnaireSampleSurveyDrawer"
                                                        fieldName="add"
                                                        label="ADD"
                                                        width={100}
                                                        style={{textAlign: "center", padding: "10px"}}
                                                        disabled={disableAdd}
                                                        onClick={addEmptyMetadata}
                                                        canHaveErrorMessage={true}
                                                        errorMessage={metadataErrorText}
                                                    />
                                                </div>
                                                <div key="metadataAddLine03" style={{float: "clear"}}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{paddingLeft: "40px"}}>
                                    <div key="SendJson09" style={{height: "40px"}}>
                                        <h3><b>Create Survey</b></h3>
                                    </div>
                                    <div key="SendJson10" style={{height: "10px"}}>&nbsp;</div>
                                </div>
                                <div key="OuterButtonContainer" style={{display: "flex", width: "100%"}}>
                                    <div key="SendButtonContainer"
                                         style={{float: "left", paddingTop: '14px', paddingLeft: "40px"}}>
                                        <ArgoButtonHook
                                            fileName="QuestionnaireSampleSurveyDrawer"
                                            fieldName="send"
                                            onClick={sendJSON}
                                            label={"Create"}
                                            width={100}
                                            disabled={disableAdd || !isPublishedOrPending}
                                            canHaveErrorMessage={true}
                                            errorMessage={totalErrorText}
                                        />
                                    </div>
                                </div>
                                <div key="SendJson08" style={{height: "30px"}}>&nbsp;</div>
                                <div key="RtnJsonContainer">
                                    {Object.keys(rtnJsonObj).length === 0 ? "" :
                                        <div style={{paddingLeft: "40px"}}>
                                            <div><b style={{fontSize: "20px"}}>Key: </b> {rtnJsonObj["key"]}</div>
                                            <div><b style={{fontSize: "20px"}}>Read Only
                                                Key: </b> {rtnJsonObj["readOnlyKey"]}</div>
                                            <div><b style={{fontSize: "20px"}}>Survey URL: </b>
                                                <a key={rtnJsonObj["referenceUrl"]} href={rtnJsonObj["referenceUrl"]}
                                                   target="_blank" rel="noopener noreferrer">{rtnJsonObj["referenceUrl"]}</a>
                                            </div>
                                            <div><b style={{fontSize: "20px"}}>Survey URL (Read Only): </b>
                                                <a key={rtnJsonObj["readOnlyUrl"]} href={rtnJsonObj["readOnlyUrl"]}
                                                   target="_blank" rel="noopener noreferrer">{rtnJsonObj["readOnlyUrl"]}</a>
                                            </div>
                                            <div><b style={{fontSize: "20px"}}>Survey URL (Read Only with
                                                Header): </b>
                                                <a key={rtnJsonObj["readOnlyUrl"] + "&header=true"} href={rtnJsonObj["readOnlyUrl"] + "&header=true"}
                                                   target="_blank" rel="noopener noreferrer">{rtnJsonObj["readOnlyUrl"] + "&header=true"}</a>
                                            </div>
                                            <div key="sndJson01" style={{height: "30px"}}>&nbsp;</div>
                                            <div key="sndJson02" style={{height: "20px"}}><b
                                                style={{fontSize: "20px"}}>Send
                                                Details</b></div>
                                            <ArgoSectionOpenCloseHook
                                                fileName="QuestionnaireSampleSurveyDrawer"
                                                fieldName="sendSectionMetadataOpen"
                                                sectionTitle={"All Properties:"}
                                                onClick={onClickToggleSectionOpenClose("send")}
                                                open={sendSectionMetadataOpen}
                                            />
                                            {sendSectionMetadataOpen ?
                                                <pre key="sndJson03" style={{width: "100%", fontSize: "16px"}}>
                                            {JSON.stringify(sendDetails, null, 4)}
                                        </pre> : ""
                                            }
                                            <div key="rtnJson01" style={{height: "20px"}}><b
                                                style={{fontSize: "20px"}}>Return
                                                Details</b></div>
                                            <ArgoSectionOpenCloseHook
                                                fileName="QuestionnaireSampleSurveyDrawer"
                                                fieldName="requestSectionMetadataOpen"
                                                sectionTitle={"All Properties:"}
                                                onClick={onClickToggleSectionOpenClose("request")}
                                                open={requestSectionMetadataOpen}
                                            />
                                            {requestSectionMetadataOpen ?
                                                <pre key="rtnJson02" style={{width: "100%", fontSize: "16px"}}>
                                            {JSON.stringify(rtnJsonObj, null, 4)}
                                        </pre> : ""
                                            }
                                            <div key="rtnJson03" style={{height: "40px"}}>&nbsp;</div>
                                        </div>
                                    }
                                </div>
                            </div> :
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <Card sx={{
                                    marginTop: "20%",
                                    boxShadow: "7px 7px 20px 2px rgba(0, 0, 0, 0.2), -7px -7px 20px 3px rgba(0, 0, 0, 0.14)",
                                    width: "40%"
                                }}>
                                    <CardHeader title={isDraft ? "***Draft Questionnaire***" : "***Published - inactive Questionnaire***"}
                                                titleTypographyProps={{
                                                    fontSize: "1.000rem",
                                                    fontWeight: "bold",
                                                    lineHeight: "normal"
                                                }}
                                    />
                                        <React.Fragment>
                                            {versionCount > 1 && props.fileName !== "TemplateVersionsList" ?
                                                <CardContent>
                                                    <Typography variant="h5" id="modal-title"
                                                                style={{color: "red", fontWeight: "bold"}}>
                                                        Warning: Cannot create sample survey from an {isDraft ? "draft" : "published - inactive"} questionnaire
                                                    </Typography>
                                                    <Typography variant="subtitle1" id="simple-modal-description"
                                                                style={{marginTop: "1%", alignItems: "center"}}>
                                                        Please click {isDraft ? '"Publish" to publish the questionnaire' : '"Change Date" to make questionnaire active '} or click "Versions" to
                                                        create sample
                                                        survey from previous version
                                                    </Typography>
                                                </CardContent>
                                                :
                                                <CardContent>
                                                    <Typography variant="h5" id="modal-title"
                                                                style={{color: "red", fontWeight: "bold"}}>
                                                        Warning: Cannot create sample survey from an {isDraft ? "draft" : "published - inactive"} questionnaire
                                                    </Typography>
                                                    <Typography variant="subtitle1" id="simple-modal-description"
                                                                style={{marginTop: "1%", alignItems: "center"}}>
                                                        Please click {isDraft ? '"Publish" to publish the questionnaire' : '"Change Date" to make questionnaire active '} to publish this questionnaire
                                                    </Typography>
                                                </CardContent>
                                            }
                                            <div key="metadataAddLine03-ADD-button"
                                                 style={{
                                                     display: "flex",
                                                     justifyContent: "center",
                                                     paddingBottom: '20px'
                                                 }}>
                                                <ArgoButtonHook
                                                    fileName="QuestionnaireSampleSurveyDrawer"
                                                    fieldName="publish"
                                                    label={isDraft ? "Publish" : "Change Date"}
                                                    width={isDraft ? 100 : 130}
                                                    style={{textAlign: "center", padding: "10px"}}
                                                    onClick={openPublishScreen.bind(null, props.template, props.template.name, props.template.nameQualifier)}
                                                />

                                                <div style={{width: "25px"}}>&nbsp;</div>

                                                {versionCount > 1 && props.fileName !== "TemplateVersionsList" ?
                                                    <ArgoButtonHook
                                                        fileName="QuestionnaireSampleSurveyDrawer"
                                                        fieldName="versions"
                                                        label="Versions"
                                                        width={100}
                                                        style={{textAlign: "center", padding: "10px"}}
                                                        onClick={openVersionsScreen.bind(null, props.template.templateKey, props.template.name, props.template.nameQualifier)}
                                                    />: ""}
                                            </div>
                                        </React.Fragment>
                                </Card>
                            </div>
                        }
                    </div>
                    : ""}
            </div>
        </ClickAwayListener>
    );
};

QuestionnaireSampleSurveyDrawerHook.defaultProps = {
    fileName: ""
};

QuestionnaireSampleSurveyDrawerHook.propTypes = {
    templateId: PropTypes.number,
    template: PropTypes.object,
    questionnaireTemplate: PropTypes.object,
    questionnaireReference: PropTypes.object,
    questionnaireRequiredTokens: PropTypes.array,
    questionnaireTemplateGraph: PropTypes.object,
    login: PropTypes.object,
    savePortalReferenceJson: PropTypes.func,
    versionsFilter: PropTypes.object,
    templateType: PropTypes.string,
    defaultActions: PropTypes.object,
    fileName: PropTypes.string
};

function mapStateToProps(state) {
    return {
        template: state.openCloseSecondaryDrawer.template,
        questionnaireTemplate: state.questionnaireTemplate,
        questionnaireReference: state.questionnaireReference,
        questionnaireRequiredTokens: state.questionnaireRequiredTokens.requiredTokens,
        questionnaireTemplateGraph: state.questionnaireTemplateGraph,
        login: state.login
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDrawer,
        openDrawer,
        publish,
        questionnaireTemplateInit,
        getQuestionnaireTemplate,
        saveQuestionnaireTemplate,
        getQuestionnaireReference,
        getMetadataRequiredTokens,
        clearQuestionnaireReference,
        initGetTemplateList,
        getQuestionnaireVersions
    }, dispatch);
}

const questionnaireSampleSurveyDrawerProps = {
    opensecondary: true,
    width: "70%",
    docked: false,
    anchor: "right"
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireSampleSurveyDrawerHook);
export {questionnaireSampleSurveyDrawerProps}